import styled from 'styled-components';
import _TableHeader from '../../atoms/table/TableHeader';
import _TableHeaderCell from '../../atoms/table/TableHeaderCell';
import _Checkbox from '../../atoms/Checkbox';
export const HeaderCell = styled(_TableHeaderCell) `
    color: ${props => props.theme.primary.base};

    @media only screen and (min-width: 992px) {
        align-items: center;
        gap: 10px;
    }
`;
export const TableHeader = styled(_TableHeader) `
    background-color: transparent;
`;
export const Checkbox = styled(_Checkbox) `
    margin-bottom: 10px;

    &:first-child&:last-child {
        margin-bottom: 10px;
    }
`;
